import { render, staticRenderFns } from "./ShopIndex.vue?vue&type=template&id=2a01976e&scoped=true&"
import script from "./ShopIndex.vue?vue&type=script&lang=ts&"
export * from "./ShopIndex.vue?vue&type=script&lang=ts&"
import style0 from "./ShopIndex.vue?vue&type=style&index=0&id=2a01976e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a01976e",
  null
  
)

export default component.exports